import React from 'react';
import { useLoader } from '../context/LoaderContext';

const Loader = () => {
  const { loading } = useLoader();
  if (!loading) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="relative">
        {/* Circular loader */}
        <div className="w-24 h-24 border-4 border-yellow-500 border-t-transparent rounded-full animate-spin"></div>
        
        {/* SPRINT text in center */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="flex">
            {['S', 'P', 'R', 'I', 'N', 'T'].map((letter, index) => (
              <span 
                key={index}
                className="text-xl font-bold text-yellow-500"
                style={{
                  animation: `pulse 0.6s ease infinite alternate ${index * 0.1}s`,
                  textShadow: '0 0 6px rgba(234, 179, 8, 0.7)'
                }}
              >
                {letter}
              </span>
            ))}
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes pulse {
          to {
            transform: scale(1.2);
            opacity: 0.8;
          }
        }
      `}</style>
    </div>
  );
};

export default Loader;